import { render } from "./AdminResume.vue?vue&type=template&id=2e134121"
import script from "./AdminResume.vue?vue&type=script&lang=js"
export * from "./AdminResume.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Gelo\\Desktop\\Firebase Project\\eporrtfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__